import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { Fragment } from 'react'

import content from 'prismic-translates/transactions-history-page.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

const tableRows = [
  {
    paymentMethod: t('table_standard_ach_label'),
    processingTime: t('24_hours'),
    methodProcessingTime: t('business_days'),
  },
  {
    paymentMethod: t('table_trustly_label'),
    processingTime: t('24_hours'),
    methodProcessingTime: t('business_days'),
  },
  {
    paymentMethod: t('table_skrill_wallet_label'),
    processingTime: t('24_hours'),
    methodProcessingTime: t('business_hours'),
  },
  {
    paymentMethod: t('table_gift_card_label'),
    processingTime: t('24_hours'),
    methodProcessingTime: t('immediately'),
  },
]

export default function TimeTable() {
  return (
    <div className={classes.root}>
      <h4 className={classes.title} data-testid='redemptions-timetable'>
        {t('redemptions_timetable')}
      </h4>

      <section className={classes.grid}>
        <div className={classes.head}>{t('payment_method')}</div>
        <div className={classes.head}>{t('processing_time')}</div>
        <div className={classes.head}>{t('method_processing_time')}</div>

        {tableRows?.map(({ paymentMethod, methodProcessingTime, processingTime }) => (
          <Fragment key={paymentMethod}>
            <div className={classes.paymentMethod}>{paymentMethod}</div>
            <div>{processingTime}</div>
            <div>{methodProcessingTime}</div>
          </Fragment>
        ))}
      </section>

      <p className={classes.hint}>{t('redemption_table_info')}</p>
    </div>
  )
}
